var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleDocs = function SvgGoogleDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 47 65"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "google_docs_svg__a",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_docs_svg__c",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_docs_svg__f",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_docs_svg__h",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_docs_svg__j",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_docs_svg__l",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "google_docs_svg__n",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "google_docs_svg__p",
    cx: "3.168%",
    cy: "2.717%",
    r: "161.249%",
    fx: "3.168%",
    fy: "2.717%",
    gradientTransform: "matrix(1 0 0 .72308 0 .008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_docs_svg__d",
    x1: "50.005%",
    x2: "50.005%",
    y1: "8.586%",
    y2: "100.014%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "google_docs_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_docs_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "nonzero",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84L36.719 10.34z",
    mask: "url(#google_docs_svg__b)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "google_docs_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_docs_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_docs_svg__d)",
    fillRule: "nonzero",
    d: "M30.664 16.431 47 32.858v-15.13z",
    mask: "url(#google_docs_svg__e)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "google_docs_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_docs_svg__f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    fillRule: "nonzero",
    d: "M11.75 47.273h23.5v-2.955h-23.5zm0 5.909h17.625v-2.955H11.75zm0-20.682v2.955h23.5V32.5zm0 8.864h23.5v-2.955h-23.5z",
    mask: "url(#google_docs_svg__g)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "google_docs_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_docs_svg__h"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#google_docs_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A1C2FA",
    fillRule: "nonzero",
    d: "M29.375 0v13.295c0 2.449 1.972 4.432 4.406 4.432H47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "google_docs_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_docs_svg__j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    fillRule: "nonzero",
    d: "M4.406 0C1.983 0 0 1.994 0 4.432v.37C0 2.363 1.983.368 4.406.368h24.969V0z",
    mask: "url(#google_docs_svg__k)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "google_docs_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_docs_svg__l"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A237E",
    fillOpacity: 0.2,
    fillRule: "nonzero",
    d: "M42.594 64.63H4.406C1.983 64.63 0 62.637 0 60.2v.37C0 63.005 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-.37c0 2.438-1.983 4.433-4.406 4.433",
    mask: "url(#google_docs_svg__m)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "google_docs_svg__o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_docs_svg__n"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A237E",
    fillOpacity: 0.1,
    fillRule: "nonzero",
    d: "M33.781 17.727c-2.434 0-4.406-1.983-4.406-4.432v.37c0 2.448 1.972 4.432 4.406 4.432H47v-.37z",
    mask: "url(#google_docs_svg__o)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google_docs_svg__p)",
    fillRule: "nonzero",
    d: "M29.375 0H4.406C1.983 0 0 1.994 0 4.432v56.136C0 63.006 1.983 65 4.406 65h38.188C45.017 65 47 63.006 47 60.568v-42.84z"
  }))));
};
export default SvgGoogleDocs;